const PARTNER = 'yaduo_atat'
const CHANNEL = 'yaduo_atat_h5'
const APPKEY = '42ea9aa6b7acd900de2f0943b1b1928f'

const BASE_URL = `https://static.trustdecision.com/tdfp/cn/${APPKEY}/fm.js`
const BOTD_BASE_URL = 'https://static.trustdecision.com/cn/botd.js'
const SCRIPT_ATTR = 'data-tdfp-sdk'
const BOTD_SCRIPT_ATTR = 'data-tdbotd-sdk'
const DEFAULT_TIMEOUT = 3000
const QUERY_HASH_RE = /[?#].*$/
const URL_HOST_RE = /^(?:[a-zA-Z][a-zA-Z\d+\-.]*:)?\/\/[^/?#]+\/?/
const TRIM_SLASH_RE = /^\/+|\/+$/g

export const TD_BLACKBOX = 'tdBlackbox'

let tdfpScriptInjected = false
let tdBotdScriptInjected = false

const setSessionStorage = function (name, value) {
  try {
    window.sessionStorage.setItem(name, value)
  } catch (error) {
    console.log('setSessionStorage error', error)
  }
}

const getSessionStorage = function (name) {
  try {
    return window.sessionStorage.getItem(name) || window.localStorage.getItem(name) || ''
  } catch (error) {
    console.log('getSessionStorage error', error)
    return ''
  }
}

const insertSdkScript = function (script) {
  const firstScript = document.getElementsByTagName('script')[0]
  const parentNode = (firstScript && firstScript.parentNode) || document.head || document.body

  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
    return
  }

  if (parentNode) {
    parentNode.appendChild(script)
  }
}

export function tdFpInit () {
  const cachedBlackbox = getSessionStorage(TD_BLACKBOX)
  if (cachedBlackbox || window.__tdfpHtmlInjected) {
    return Promise.resolve(cachedBlackbox)
  }

  return new Promise((resolve) => {
    let settled = false
    let timerId = null

    const done = (value) => {
      if (settled) return
      settled = true
      if (timerId !== null) clearTimeout(timerId)
      setSessionStorage(TD_BLACKBOX, value)
      resolve(value)
    }

    if (tdfpScriptInjected) {
      return done(cachedBlackbox)
    }

    window._fmOpt = {
      partner: PARTNER,
      appName: CHANNEL,
      channel: CHANNEL,
      appKey: APPKEY,
      success (data) {
        done(data)
      }
    }

    timerId = setTimeout(() => {
      done(getSessionStorage(TD_BLACKBOX) || cachedBlackbox)
    }, DEFAULT_TIMEOUT)

    const existed =
          document.querySelector(`script[${SCRIPT_ATTR}]`) ||
          document.querySelector(`script[src^="${BASE_URL}"]`)
    if (existed) {
      tdfpScriptInjected = true
    } else {
      const fm = document.createElement('script')
      fm.setAttribute(SCRIPT_ATTR, 'true')
      fm.type = 'text/javascript'
      fm.async = true
      fm.src = `${BASE_URL}?t=` + Math.floor(Date.now() / 3600000)
      fm.onload = () => {
        tdfpScriptInjected = true
      }
      fm.onerror = () => {
        done(cachedBlackbox)
      }

      insertSdkScript(fm)
    }
  })
}

export const getTdBlackbox = function () {
  return getSessionStorage(TD_BLACKBOX)
}

export const getTdBlackboxInfo = function () {
  return typeof window !== 'undefined' && window._fmOpt && window._fmOpt.getinfo
    ? window._fmOpt.getinfo()
    : ''
}

export const tdBotdInit = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return
  }

  if (window._TDBotD && typeof window._TDBotD.sign === 'function') {
    return
  }

  const existed =
      document.querySelector(`script[${BOTD_SCRIPT_ATTR}]`) ||
      document.querySelector(`script[src^="${BOTD_BASE_URL}"]`)

  if (tdBotdScriptInjected || window.__tdBotdHtmlInjected || existed) {
    tdBotdScriptInjected = true
    window.__tdBotdHtmlInjected = true
    return
  }

  window._TDBotD = window._TDBotD || {}

  const botd = document.createElement('script')
  botd.setAttribute(BOTD_SCRIPT_ATTR, 'true')
  botd.type = 'text/javascript'
  botd.async = true
  botd.src = `${BOTD_BASE_URL}?t=` + Math.floor(Date.now() / 3600000)
  botd.onload = () => {
    tdBotdScriptInjected = true
    window.__tdBotdHtmlLoaded = true
  }

  tdBotdScriptInjected = true
  window.__tdBotdHtmlInjected = true
  insertSdkScript(botd)
}

const removeQueryAndHash = function (url) {
  return String(url || '').trim().replace(QUERY_HASH_RE, '')
}

export function normalizeTdSignPath (url) {
  return removeQueryAndHash(url)
    .replace(URL_HOST_RE, '')
    .replace(TRIM_SLASH_RE, '')
}

const getTdSignPath = function (requestUrl = '', baseURL = '') {
  const pureRequestUrl = removeQueryAndHash(requestUrl)
  const requestPath = normalizeTdSignPath(pureRequestUrl)
  const basePath = URL_HOST_RE.test(pureRequestUrl) ? '' : normalizeTdSignPath(baseURL)

  return requestPath ? [basePath, requestPath].filter(Boolean).join('/') : ''
}

export function getTdSign (requestUrl, baseURL = '') {
  const path = getTdSignPath(requestUrl, baseURL)
  const sign = typeof window !== 'undefined' && window._TDBotD && window._TDBotD.sign

  if (!path || typeof sign !== 'function') {
    return ''
  }

  try {
    const signResult = sign({ path })
    return signResult && signResult.code === 0 ? signResult.sign || '' : ''
  } catch (error) {
    console.log('getTdSign error', error)
    return ''
  }
}

export const getTdClientHeaders = function (requestUrl = '', baseURL = '', isNeedTdSign = false) {
  const headers = {}
  const tdBlackbox = getTdBlackbox() || getTdBlackboxInfo()

  if (tdBlackbox) {
    headers['At-Client-Code'] = tdBlackbox
  }

  if (isNeedTdSign === true) {
    const tdSign = getTdSign(requestUrl, baseURL)
    if (tdSign) {
      headers['At-Client-Sign'] = tdSign
    }
  }

  return headers
}



// WEBPACK FOOTER //
// ./src/utils/tdfp.js